/* @generated */

// ../src/progress_indicators/interstitial/interstitial.tsx
import { useTheme } from "@dropbox/dig-foundations";
import classNames from "classnames";
import * as React from "react";
import { CSSTransition } from "react-transition-group";

// ../src/progress_indicators/interstitial/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var interstitialCssTransitionStyle = "dig-umnl38a_21-4-0";
var interstitialDotOneStyle = "dig-umnl38b_21-4-0";
var interstitialDotStyle = "dig-umnl389_21-4-0";
var interstitialDotTwoStyle = "dig-umnl38c_21-4-0";
var interstitialInnerStyle = "dig-umnl388_21-4-0";
var interstitialRecipe = _7a468({ defaultClassName: "dig-umnl386_21-4-0", variantClassNames: { complete: { true: "dig-umnl387_21-4-0" } }, defaultVariants: {}, compoundVariants: [] });
var interstitialTrackStyle = "dig-umnl385_21-4-0";

// ../src/progress_indicators/interstitial/interstitial.tsx
var STARTING_OFFSET = 800;
var END_OFFSET = 100;
var OFFSET_DIFF = STARTING_OFFSET - END_OFFSET;
var Interstitial = ({
  className,
  onComplete,
  value = 0,
  isIndeterminate = false,
  inverse = false,
  "aria-valuetext": ariaValueText,
  ...rest
}) => {
  const clampedValue = Math.min(100, Math.max(0, value));
  const inverseClassName = useTheme().getInverseProps().className;
  const ref = React.useRef(null);
  const [complete, setComplete] = React.useState(false);
  const trackRectRef = React.useRef(null);
  const cls = classNames(
    "dig-Interstitial",
    interstitialRecipe({ complete }),
    {
      "dig-Interstitial--isIndeterminate": isIndeterminate,
      "dig-Interstitial--complete": complete,
      [inverseClassName]: inverse
    },
    className
  );
  const a11yProps = {};
  if (isIndeterminate) {
    a11yProps["aria-valuetext"] = ariaValueText;
  } else {
    a11yProps["aria-valuenow"] = clampedValue;
    a11yProps["aria-valuemin"] = 0;
    a11yProps["aria-valuemax"] = 100;
  }
  const timeout2 = {
    exit: 1e3
  };
  const handleTransitionEnd = (evt) => {
    if (!ref || ref.current !== evt.target)
      return;
    if (complete && onComplete) {
      onComplete();
      setComplete(false);
    }
  };
  React.useEffect(() => {
    if (value >= 100 && !complete) {
      setComplete(true);
    }
    const updateTrack = () => {
      const offset = Math.max(STARTING_OFFSET - clampedValue / 100 * OFFSET_DIFF, 0);
      if (trackRectRef && trackRectRef.current) {
        trackRectRef.current.setAttribute("stroke-dashoffset", offset.toString());
      }
    };
    updateTrack();
  }, [value, complete, clampedValue, trackRectRef]);
  return /* @__PURE__ */ React.createElement(
    CSSTransition,
    {
      timeout: timeout2,
      classNames: classNames("dig-Interstitial-container", interstitialCssTransitionStyle),
      unmountOnExit: true,
      ...rest
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "progressbar",
        ...a11yProps,
        className: cls,
        onTransitionEnd: handleTransitionEnd,
        ref
      },
      /* @__PURE__ */ React.createElement("div", { className: classNames("dig-Interstitial-inner", interstitialInnerStyle) }, !isIndeterminate && /* @__PURE__ */ React.createElement(
        "svg",
        {
          className: classNames("dig-Interstitial-track", interstitialTrackStyle),
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 300 300",
          "aria-hidden": "true",
          focusable: "false"
        },
        /* @__PURE__ */ React.createElement(
          "rect",
          {
            fill: "none",
            stroke: "currentColor",
            strokeLinecap: "square",
            strokeWidth: "100",
            x: "50",
            y: "50",
            width: "200",
            height: "200",
            ref: trackRectRef
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(
            "dig-Interstitial-dot",
            "dig-Interstitial-dot--one",
            interstitialDotStyle,
            interstitialDotOneStyle
          )
        }
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(
            "dig-Interstitial-dot",
            "dig-Interstitial-dot--two",
            interstitialDotStyle,
            interstitialDotTwoStyle
          )
        }
      ))
    )
  );
};
Interstitial.displayName = "Interstitial";

// ../src/progress_indicators/progress_bar/progress_bar.tsx
import * as React2 from "react";
import cx from "classnames";
import { CSSTransition as CSSTransition2 } from "react-transition-group";
import { useTheme as useTheme2 } from "@dropbox/dig-foundations";

// ../src/progress_indicators/progress_bar/index.css.ts
import { createRuntimeFn as _7a4682 } from "@vanilla-extract/recipes/createRuntimeFn";
var progressBarCompleteStyle = "dig-uq0kcze_21-4-0";
var progressBarContainerRecipe = _7a4682({ defaultClassName: "dig-uq0kcz6_21-4-0", variantClassNames: { isStatic: { true: "dig-uq0kcz7_21-4-0", false: "dig-uq0kcz8_21-4-0" }, isIndeterminate: { true: "dig-uq0kcz9_21-4-0", false: "dig-uq0kcza_21-4-0", undefined: "dig-uq0kczb_21-4-0" } }, defaultVariants: {}, compoundVariants: [] });
var progressBarTrackInnerStyle = "dig-uq0kczd_21-4-0";
var progressBarTrackStyle = "dig-uq0kczc_21-4-0";

// ../src/progress_indicators/progress_bar/progress_bar.tsx
var timeout = {
  exit: 1e3
};
var getAriaProps = (value) => ({
  "aria-valuenow": value,
  "aria-valuemin": 0,
  "aria-valuemax": 100
});
var ProgressBarTrack = ({ showInner, className, ...rest }) => /* @__PURE__ */ React2.createElement("div", { ...rest, className: cx(className, "dig-ProgressBar-track", progressBarTrackStyle) }, showInner && /* @__PURE__ */ React2.createElement("div", { className: cx("dig-ProgressBar-track-inner", progressBarTrackInnerStyle) }));
var ProgressBar = ({
  className,
  value = 0,
  inverse = false,
  isStatic,
  ...rest
}) => {
  const scale = Math.min(1, Math.max(0, value / 100));
  const inverseClassName = useTheme2().getInverseProps().className;
  if (isStatic) {
    const cls2 = cx(
      "dig-ProgressBar-container",
      "dig-ProgressBar--static",
      progressBarContainerRecipe({ isStatic: true }),
      className,
      {
        [inverseClassName]: inverse
      }
    );
    const trackStyle2 = {
      transform: `scaleX(${scale})`
    };
    const a11yProps2 = getAriaProps(value);
    return /* @__PURE__ */ React2.createElement("div", { role: "progressbar", ...a11yProps2, className: cls2, ...rest }, /* @__PURE__ */ React2.createElement(ProgressBarTrack, { style: trackStyle2 }));
  }
  const { isIndeterminate, onComplete, "aria-valuetext": ariaValueText, ...restDynamic } = rest;
  const trackStyle = {};
  let a11yProps = {};
  const cls = cx(
    "dig-ProgressBar-container",
    progressBarContainerRecipe({ isStatic: false, isIndeterminate: !!isIndeterminate }),
    className,
    {
      "dig-ProgressBar--determinate": !isIndeterminate,
      "dig-ProgressBar--indeterminate": isIndeterminate,
      "dig-ProgressBar--inverse": inverse
    }
  );
  if (isIndeterminate) {
    a11yProps["aria-valuetext"] = ariaValueText;
  } else {
    trackStyle.transform = `scaleX(${scale})`;
    a11yProps = getAriaProps(value);
  }
  const trackIterate = (evt) => {
    if (value >= 100 && (evt.animationName === "progressBarIndeterminateTranslate" || !isIndeterminate)) {
      if (onComplete)
        onComplete();
    }
  };
  return /* @__PURE__ */ React2.createElement(
    CSSTransition2,
    {
      timeout,
      classNames: cx(
        "dig-ProgressBar-container",
        progressBarContainerRecipe({ isStatic: false, isIndeterminate: void 0 })
      ),
      unmountOnExit: true,
      ...restDynamic
    },
    /* @__PURE__ */ React2.createElement("div", { role: "progressbar", ...a11yProps, className: cls }, /* @__PURE__ */ React2.createElement(
      ProgressBarTrack,
      {
        style: trackStyle,
        onAnimationIteration: trackIterate,
        showInner: !isIndeterminate
      }
    ), /* @__PURE__ */ React2.createElement("div", { className: cx("dig-ProgressBar-complete", progressBarCompleteStyle) }))
  );
};
ProgressBar.displayName = "ProgressBar";

// ../src/progress_indicators/spinner/spinner.tsx
import classnames from "classnames";
import * as React3 from "react";

// ../src/_global/sizes.tsx
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getLegacyComponentSize = (size) => {
  const mapping = deprecationMap.find(([newVal, _deprecatedVal]) => size === newVal);
  if (mapping !== void 0) {
    return mapping[1];
  }
  return size;
};
var getMigratedComponentSize = (size) => {
  const mapping = deprecationMap.find(([_newVal, deprecatedVal]) => size === deprecatedVal);
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/progress_indicators/spinner/spinner.tsx
import { useTheme as useTheme3 } from "@dropbox/dig-foundations";

// ../src/progress_indicators/spinner/index.css.ts
import { createRuntimeFn as _7a4683 } from "@vanilla-extract/recipes/createRuntimeFn";
var spinnerContentRecipe = _7a4683({ defaultClassName: "dig-q8afrb8_21-4-0", variantClassNames: { size: { xsmall: "dig-q8afrb9_21-4-0", small: "dig-q8afrba_21-4-0", medium: "dig-q8afrbb_21-4-0", large: "dig-q8afrbc_21-4-0" } }, defaultVariants: {}, compoundVariants: [] });
var spinnerDotRecipe = _7a4683({ defaultClassName: "dig-q8afrbe_21-4-0", variantClassNames: { location: { one: "dig-q8afrbf_21-4-0", two: "dig-q8afrbg_21-4-0" }, monochromatic: { true: "dig-q8afrbh_21-4-0" } }, defaultVariants: {}, compoundVariants: [] });
var spinnerRecipe = _7a4683({ defaultClassName: "dig-q8afrb2_21-4-0", variantClassNames: { size: { xsmall: "dig-q8afrb3_21-4-0", small: "dig-q8afrb4_21-4-0", medium: "dig-q8afrb5_21-4-0", large: "dig-q8afrb6_21-4-0" }, hasOpaqueTrack: { true: "dig-q8afrb7_21-4-0" } }, defaultVariants: {}, compoundVariants: [] });
var spinnerTrackStyle = "dig-q8afrbd_21-4-0";

// ../src/progress_indicators/spinner/spinner.tsx
var TrackSVG = () => /* @__PURE__ */ React3.createElement(
  "svg",
  {
    className: classnames("dig-Spinner--track", spinnerTrackStyle),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false",
    "data-testid": "digSpinnerTrack"
  },
  /* @__PURE__ */ React3.createElement("rect", { fill: "none", strokeLinecap: "square", strokeWidth: "6", x: "3", y: "3", width: "18", height: "18" })
);
var Spinner = ({
  "aria-valuetext": ariaValueText,
  className,
  withTrack = true,
  inverse,
  size: _size = "medium",
  monochromatic = false,
  hasOpaqueTrack = false,
  ...rest
}) => {
  const size = getMigratedComponentSize(_size);
  const inverseClassName = useTheme3().getInverseProps().className;
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      role: "progressbar",
      "aria-valuetext": ariaValueText,
      className: classnames(
        "dig-Spinner",
        className,
        spinnerRecipe({ hasOpaqueTrack, size }),
        `dig-Spinner--${getLegacyComponentSize(size)}`,
        {
          "dig-Spinner--medium": size === "medium",
          [inverseClassName]: inverse,
          "dig-Spinner--monochromatic": monochromatic,
          "dig-Spinner--hasOpaqueTrack": hasOpaqueTrack
        }
      ),
      ...rest
    },
    /* @__PURE__ */ React3.createElement("div", { className: classnames("dig-Spinner-content", spinnerContentRecipe({ size })) }, withTrack && /* @__PURE__ */ React3.createElement(TrackSVG, null), /* @__PURE__ */ React3.createElement(
      "div",
      {
        className: classnames(
          "dig-Spinner-dot",
          "dig-Spinner-dot--one",
          spinnerDotRecipe({ location: "one", monochromatic })
        )
      }
    ), /* @__PURE__ */ React3.createElement(
      "div",
      {
        className: classnames(
          "dig-Spinner-dot",
          "dig-Spinner-dot--two",
          spinnerDotRecipe({ location: "two", monochromatic })
        )
      }
    ))
  );
};
export {
  Interstitial,
  ProgressBar,
  Spinner
};
